<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.5 12H12V5.5A1.5 1.5 0 0010.5 4h-7A1.5 1.5 0 002 5.5v15A1.5 1.5 0 003.5 22h7a1.64 1.64 0 00.5-.09 1.64 1.64 0 00.5.09h9a1.5 1.5 0 001.5-1.5v-7a1.5 1.5 0 00-1.5-1.5zM10 6v10.5H4V6zM4 17.5h6V20H4zM20 20h-8v-6h8zM13.4 3a5.51 5.51 0 015.47 4.92l-2-1.41a.5.5 0 00-.57.82l2.89 2a.52.52 0 00.29.09h.09a.47.47 0 00.32-.21l2-2.89a.51.51 0 00-.12-.7.5.5 0 00-.7.13l-1.26 1.8A6.52 6.52 0 0013.4 2a.5.5 0 000 1z"/></svg>